import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import PreRegister from './components/PreRegister';
import FAQ from './components/FAQ';
import PrivacyPolicy from './components/PrivacyPolicy';
import "./theme/global.css"
import "./theme/variables.css";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/presignup" element={<PreRegister />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/YoyoLandingPage" element={<Home />} />
        <Route path="/YoyoLandingPage/presignup" element={<PreRegister />} />
        <Route path="/YoyoLandingPage/faq" element={<FAQ />} />
        <Route path="/YoyoLandingPage/privacy" element={<PrivacyPolicy />} />
        <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;
